(function ($) {
  $(document).ready(function () {
    menus();
  });

  // Menu functions
  function menus() {
    const ENTER_KEY = 13;
    const $header = $(".header-megamenu");
    let $linksWithSubMenu = [];
    let $subMenuElements = [];
    let $closeButtons = [];

    const init = () => {
      $subMenuElements = $(
        ".header-megamenu > ul > li.menu-item-has-children > a"
      );

      $subMenuElements.each((index, el) => {
        var plusButton = "<span class='open-submenu'></span>";
        var added = $(el).append($(plusButton));
        $(added).appendTo(el);
      });

      $linksWithSubMenu = $(
        ".header-megamenu > ul > li.menu-item-has-children > a"
      );

      $linksWithSubMenu.each((index, el) => {
        setAriaAttributes($(el));
        addMouseEvents($(el));
        addTouchEvents($(el));
        addKeyboardEvents($(el));
      });

      $closeButtons = $(".sub-menu__close, .js-close-submenu");

      $closeButtons.each((index, el) => {
        closeMenu($(el));
      });

      $(document).on("click", function (event) {
        const $target = $(event.target);
        if (!$header.has($target).length) {
          closeAllSubMenus();
        }
      });

      closeSubMenusOnFocusWithin($("#site-content"));
    };

    const setAriaAttributes = ($el) => {
      $el.attr("aria-haspopup", true);
      $el.attr("aria-expanded", false);
    };

    const addMouseEvents = ($el) => {
      $el.parent().on("mouseover", onMouseOver);
      $el.parent().on("mouseleave", onMouseLeave);
      $el.on("click", onPress);
    };

    const closeMenu = ($el) => {
      $el.on("click", closeAllSubMenus);
    };

    const addTouchEvents = ($el) => {
      $el.on("touchstart", onPress);
    };

    const addKeyboardEvents = ($el) => {
      $el.on("keydown", onKeydown);
    };

    const onMouseOver = (e) => {
      const $el = $(e.currentTarget).find("> a");
      $el.attr("aria-expanded", true);
    };

    const onMouseLeave = (e) => {
      const $el = $(e.currentTarget).find("> a");
      $el.attr("aria-expanded", false);
    };

    const onPress = (e) => {
      const $el = $(e.currentTarget);
      e.preventDefault();

      if (!isOpen($el)) {
        openSubMenu($el);
      } else {
        closeSubMenu($el);
      }
    };

    const onKeydown = (e) => {
      if (e.keyCode === ENTER_KEY) {
        onPress(e);
      }
    };

    const openSubMenu = ($el) => {
      if (!isInsideSubMenu($el)) {
        closeAllSubMenus();
      }

      $header.addClass("is-open");
      $el.parent().addClass("is-open");
      $el.attr("aria-expanded", true);
    };

    const closeSubMenu = ($el) => {
      $header.removeClass("is-open");
      $("li.is-open").removeClass("is-open");
      $el.parent().removeClass("is-open");
      $el.attr("aria-expanded", false);
    };

    const closeAllSubMenus = () => {
      $linksWithSubMenu.each((index, el) => {
        closeSubMenu($(el));
      });
    };

    const isOpen = ($el) => {
      return $el.parent().hasClass("is-open");
    };

    const isInsideSubMenu = ($el) => {
      const $ancestorLinkWithSubMenu = $el
        .parent()
        .parent()
        .closest("li.menu-item-has-children");
      return $ancestorLinkWithSubMenu.length > 0;
    };

    const closeSubMenusOnFocusWithin = ($el) => {
      $el.on("focusin", () => {
        closeAllSubMenus();
      });
    };

    init();
  }
})(jQuery);
